import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login";
import MainMenu from "./views/MainMenu";
import ManageUser from "./views/Settings/ManageUser";
import ManageRole from "./views/Settings/ManageRole";
import MeetingRoomScreen from "./views/MeetingRoomScreen";
import Facility from "./views/Infrastructure/Facility";
import Location from "./views/Infrastructure/Location";
import Utility from "./views/Infrastructure/Utility";
import Zone from "./views/Infrastructure/Zone";
import TransactionRoomBooking from "./views/TransactionRoomBooking";
import CheckinMeeting from "./views/CheckinMeeting";
import Roompad from "./views/Roompad";
import ReservationCondition from "./views/ReservationCondition";
import Order from "./views/Order";
import MyOrder from "./views/MyOrder";
import ManageOrder from "./views/ManageOrder";
import AllBooking from "./views/AllBooking";
import Dashboard from "./views/Dashboard";
import ViewSchedule from "./views/ViewSchedule";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: {
        name: "Login",
      },
    },
    {
      path: "/Login",
      name: "Login",
      component: Login,
    },
    {
      path: "/MainMenu",
      name: "MainMenu",
      component: MainMenu,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ManageUser",
      name: "ManageUser",
      component: ManageUser,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ManageRole",
      name: "ManageRole",
      component: ManageRole,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/MeetingRoomScreen",
      name: "MeetingRoomScreen",
      component: MeetingRoomScreen,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Facility",
      name: "Facility",
      component: Facility,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Location",
      name: "Location",
      component: Location,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Utility",
      name: "Utility",
      component: Utility,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Zone",
      name: "Zone",
      component: Zone,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/TransactionRoomBooking",
      name: "TransactionRoomBooking",
      component: TransactionRoomBooking,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Roompad",
      name: "Roompad",
      component: Roompad,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ReservationCondition",
      name: "ReservationCondition",
      component: ReservationCondition,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Order",
      name: "Order",
      component: Order,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/MyOrder",
      name: "MyOrder",
      component: MyOrder,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ManageOrder",
      name: "ManageOrder",
      component: ManageOrder,
      meta: { requiresAuth: true },
    },
    {
      path: "/ManageOrder/:orderId(\\d+)",
      name: "ManageOrderDetail",
      component: ManageOrder,
      meta: { requiresAuth: true },
    },
    {
      path: "/AllBooking",
      name: "AllBooking",
      component: AllBooking,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ViewSchedule",
      name: "ViewSchedule",
      component: ViewSchedule,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/CheckinMeeting/:eventID",
      name: "CheckinMeeting",
      component: CheckinMeeting,
    },
  ],
});

function getSafeRedirect(value) {
  return typeof value === "string" && value.startsWith("/") && !value.startsWith("//")
    ? value
    : null;
}

router.beforeEach((to, from, next) => {
  const token = Vue.$cookies.get("Token") || localStorage.getItem("Token");
  const isLoggedIn =
    Vue.$cookies.get("isLoggedIn") === true ||
    Vue.$cookies.get("isLoggedIn") === "true" ||
    localStorage.getItem("isLoggedIn") === "true";

  if (to.matched.some((r) => r.meta.requiresAuth)) {
    if (!token || !isLoggedIn) {
      return next({ name: "Login", query: { redirect: to.fullPath } });
    }
  }
  const roleID = Vue.$cookies.get("roleID") || localStorage.getItem("roleID");
  if (to.name === "Login" && token && isLoggedIn) {
    if (roleID == 3) {
      return next("/MeetingRoomScreen");
    }
    return next(getSafeRedirect(to.query.redirect) || "/Dashboard");
  }

  next();
});

export default router;
